<template>
    <div class="head-bar">
        <div class="w-content">
            <div class="serm-logo" @click="toHome">
                <i></i><span>规则中心</span>
            </div>
            <div class="serm-search">
                <div class="search-box">
                    <input type="text" v-model="searchword" @keypress="enter" class="searchin" maxlength="30" placeholder="请输入规则关键字">
                    <button @click="searchBtn">搜索</button>
                </div>
                <p class="sertuij">
            	    <span>热门搜索：</span>
                    <ul>
                        <li v-for="(text, index) in listHotWord" @click="search(text)" :key=index>
                            {{text}}
                        </li>
                        
                    </ul>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import {http,$tracker} from '@utils'
import {host} from '@utils/api'
import Bus from '@utils/bus'
export default {
    data(){
        return {
            listHotWord:[]
        }
    },
    computed: {
        // ...mapState(['searchword']),
        searchword: {
            get() {
                return this.$store.state.searchword
            },
            set(v) {
                this.$store.commit('setSearchword',v)
            }
        }
    },
    created(){
        this.getCmsHotWord()
    },
    methods:{
        ...mapActions(['toSearchByQuery']),
        searchBtn(){
            $tracker('288950',20000,'200001')
            const routeObj = { name: 'search', query: { searchword:this.searchword }};
            // if(this.$route.query && this.$route.query.searchword == this.searchword){return false}
            if(this.$route.name == 'search') {
                this.$router.replace(routeObj).catch(err => {err})
            } else {
                this.$router.push(routeObj).catch(err => {err})
            }
            const param = {
                searchword:this.searchword,
                current: 1,
                pagesize:10,
            }
            Bus.$emit('initSearchParams');
            this.toSearchByQuery(param); 
        },
        enter(e){
            const keycode = document.all ? event.keyCode : e.which;
            if (keycode == 13) {
                this.searchBtn()
            }
        },
        search(text){
            const searchword = text;
            const routeObj = { name: 'search', query: { searchword }};
            // if(this.$route.query && this.$route.query.searchword == this.searchword){return false}
            if(this.$route.name == 'search') {
                this.$router.replace(routeObj).catch(err => {err})
            } else {
                this.$router.push(routeObj).catch(err => {err})
            }
            const param = {
                searchword,
                current: 1,
                pagesize:10,
            }
            Bus.$emit('initSearchParams');
            this.toSearchByQuery(param); 
        },
        async getCmsHotWord(){
            const response = await http.get(`${host.cmsHost}/publish/976/ruleHotWord.json`);
            if(response && response.data) {
                this.listHotWord = response.data.hotWord;
            }
        },
        toHome(){
            location.href = '/pages'
            //this.$router.push({name:'pages'})
        }
    }
}
</script>

<style lang="scss" scoped>
    .head-bar {
        height: 100px;
        background-color: #fff;
        .w-content {
            height: 100%;
            display: flex;
            justify-content: space-between;
            padding: 0 30px;
            .serm-logo {
                display: flex;
                align-items: center;
                cursor: pointer;
                i {
                    width: 144px;
                    height: 48px;
                    background: url('~@assets/images/logo.png') no-repeat;
                    background-size: 100% auto;
                }
                span {
                    font-size: 20px;
                    color: #333333;
                    position: relative;
                    padding-left: 10px;
                    margin-top: 8px;
                    // &::before {
                    //     content: "";
                    //     position: absolute;
                    //     background: #999999;
                    //     width: 4px;
                    //     height: 4px;
                    //     border-radius: 4px;
                    //     left: 0;
                    //     top: 50%;
                    //     transform: translateY(-50%);
                    // }
                }
            }
            .serm-search {
                width: 530px;
                padding-top: 30px;
                .search-box {
                    width: 100%;
                    background-color: #1C7AE5;
                    display: flex;
                    height: 38px;
                    input {
                        width: 450px;
                        background-color: #fff;
                        margin: 2px;
                        height: 34px;
                        line-height: 34px;
                        border: 0;
                        padding: 0 12px;
                        font-size: 12px;
                    }
                    button{
                        flex-grow:1;
                        border: 0;
                        background-color: transparent;
                        cursor: pointer;
                        font-size: 16px;
                        line-height: 38px;
                        color: #FFFFFF;
                    }
                }
                .sertuij {
                    height: 30px;
                    line-height: 30px;
                    display: flex;
                    >span {
                        font-size: 12px;
                        color: #666666;
                    }
                    ul {
                        display: flex;
                        li {
                            padding-left: 20px;
                            font-size: 12px;
                            color: #FF3A00;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
</style>
